import { API_BASE_URL } from 'config'

import axios from 'axios'
import PropTypes from 'prop-types'
import { kea } from 'kea'
import { put, call } from 'redux-saga/effects'
// import TariffSubscribeModal from 'containers/TariffSubscribeModal/logic'

const PRICELIST_ENDPOINT = `${API_BASE_URL}/public/price-list`
const MARKET_SEGMENT_ENDPOINT = `${API_BASE_URL}/public/market-segment`

export default kea({
  actions: () => ({
    fetchTariffInfo: (id) => ({ id }),
    setTariffInfo: (tariffInfo) => ({ tariffInfo }),
    setFetchError: (message) => ({ message })
  }),
  reducers: ({ actions }) => ({
    tariffInfo: [null, PropTypes.object, {
      [actions.setTariffInfo]: (_, payload) => payload.tariffInfo
    }],

    loading: [true, PropTypes.bool, {
      [actions.fetchTariffInfo]: () => true,
      [actions.setTariffInfo]: () => false,
      [actions.setFetchError]: () => false
    }]
  }),
  takeLatest: ({ actions, workers }) => ({
    [actions.fetchTariffInfo]: workers.fetchTariffInfo
  }),
  workers: {
    * fetchTariffInfo (action) {
      const { id } = action.payload
      const { setTariffInfo, setFetchError } = this.actions

      if (id) {
        try {
          const info = yield call(axios.get, `${PRICELIST_ENDPOINT}/${id}/`)
          const data = info.data

          const marketSegmentsList = data.pricelistadditionalinfo.market_segment_type || []
          const marketSegmentsData = []

          for (const id of marketSegmentsList) {
            const singleMs = yield call(axios.get, `${MARKET_SEGMENT_ENDPOINT}/${id}/`)
            marketSegmentsData.push(singleMs.data)
          }

          data.pricelistadditionalinfo.market_segment_type = marketSegmentsData.map(({ name }) => name).join(', ')

          yield put(setTariffInfo(info.data))
        } catch (error) {
          yield put(setFetchError(error))
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/containers/ResultsList/logic.js